import React, {useEffect, useState} from 'react';
import {Card, Col, Row, Spin, Tag} from 'antd';
import {Link} from 'react-router-dom';
import api from '../../api';
import {useTranslations} from '../../lang';
import {DEFAULT_GUTTER} from '../../constants';
import Footer from '../../Components/Footer';
import SEOHead from '../../Components/SEOHead';
import CallToAction from '../../Components/CallToAction';
import './style.css';

export default function Blog() {
    const {translate: t, language} = useTranslations();
    const [posts, setPosts] = useState([]);
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            api.getAllBlogs(language, 10),
            api.getBlogTags(language)
        ]).then(([postsData, tagsData]) => {
            setPosts(postsData);
            setTags(tagsData);
        }).finally(() => {
            setLoading(false);
        });
    }, [language]);

    if (loading) {
        return (
            <div className="loading-container">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <>
            <SEOHead
                title={`${t('Blog')} - Oogst.app`}
                description={t('Lees onze blog artikelen over moestuinieren')}
                keywords="blog, moestuin, oogst, groenten"
            />
            <div className="blog-page">
                <Row gutter={DEFAULT_GUTTER}>
                    <Col xs={24} md={18}>
                        <h1>{t('Blog')}</h1>
                        <div className="blog-posts">
                            {posts.map(post => (
                                <Card key={post.id} className="mar-b-2">
                                    <Row gutter={DEFAULT_GUTTER}>
                                        {post.thumbnail && (
                                            <Col xs={24} md={6}>
                                                <Link to={`/blog/${post.slug}`}>
                                                    <img
                                                        src={post.thumbnail}
                                                        alt={post.title}
                                                        className="blog-thumbnail"
                                                    />
                                                </Link>
                                            </Col>
                                        )}
                                        <Col xs={24} md={post.thumbnail ? 18 : 24}>
                                            <Link to={`/blog/${post.slug}`}>
                                                <h2 className="blog-post-title">{post.title}</h2>
                                            </Link>
                                            <p className="blog-post-description">{post.meta_description}</p>
                                            {post.tags && post.tags.length > 0 && (
                                                <div className="blog-post-tags">
                                                    {post.tags.map(tag => (
                                                        <Link key={tag.id} to={`/blog/tag/${tag.tag}`}>
                                                            <Tag>{tag.tag}</Tag>
                                                        </Link>
                                                    ))}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Card>
                            ))}
                        </div>
                    </Col>
                    <Col xs={24} md={6}>
                        <h2>{t('Tags')}</h2>
                        <div className="blog-tags-sidebar">
                            {tags.map(tag => (
                                <Link key={tag.tag} to={`/blog/tag/${tag.tag}`}>
                                    <Tag className="mar-b-1">{tag.tag} ({tag.count})</Tag>
                                </Link>
                            ))}
                        </div>
                    </Col>
                </Row>
            </div>
            <CallToAction />
            <Footer />
        </>
    );
}
